import React from 'react';
import i18n, { getPluralText } from '@i18n';
import PopupNg from '@/ui/PopupNg';
import Dialog, { DialogActions, DialogBody, DialogButton, DialogTitle } from '../dialogs/Dialog';
import PropTypes from 'prop-types';

export class LogoutPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { buttonEnabled: true };
        this.onEnd = this.onEnd.bind(this);
    }

    componentWillUnmount() {
        if (this._timeout) {
            clearTimeout(this._timeout);
        }
    }

    onEnd() {
        this.setState({ buttonEnabled: false });
        sessionStorage.removeItem('data-change-verification');
        this._timeout = setTimeout(() => {
            window.location.href = '/doLogout';
        }, 500);
    }

    render() {
        const { buttonEnabled } = this.state;
        const onClose = PopupNg.dispatcher.close;

        return (
            <Dialog className="logout-dialog">
                <DialogTitle>
                    <h2>{i18n('logout.popup.header')}</h2>
                </DialogTitle>
                <DialogBody>
                    <Countdown initialSeconds={3} onEnd={this.onEnd} />
                </DialogBody>
                {buttonEnabled ? (
                    <DialogActions>
                        <DialogButton onClick={onClose}>{i18n('logout.popup.cancelLogout')}</DialogButton>
                    </DialogActions>
                ) : null}
            </Dialog>
        );
    }
}

class Countdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            secondsRemaining: props.initialSeconds,
            initState: true
        };
    }

    static propTypes = {
        initialSeconds: PropTypes.number
    };
    static defaultProps = {
        initialSeconds: 3
    };

    tick() {
        this.setState({ secondsRemaining: this.state.secondsRemaining - 1 });
        if (this.state.secondsRemaining <= 0) {
            clearInterval(this.interval);
            this.props.onEnd();
        }
    }

    progressPercent() {
        if (this.state.initState) {
            return 100;
        }
        const max = this.props.initialSeconds;
        const current = this.state.secondsRemaining - 1;
        return 100 * (1 - (max - current) / max);
    }

    componentDidMount() {
        setTimeout(() => {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.initState = false;
            this.forceUpdate();
        }, 50);
        this.interval = setInterval(this.tick.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <>
                <TextProgress secondsRemaining={this.state.secondsRemaining} />
                <UIProgress progressPercent={this.progressPercent()} />
            </>
        );
    }
}

const TextProgress = props => (
    <span dangerouslySetInnerHTML={{ __html: getPluralText('logout.popup.text', props.secondsRemaining) }} />
);

const UIProgress = props => (
    <div className="progress-wrap">
        <div className="progress">
            <div
                className="progress-bar"
                style={{ width: props.progressPercent + '%', display: props.progressPercent < 0 ? 'none' : 'block' }}
            />
        </div>
    </div>
);
